import { gql } from "@apollo/client";

export const USER_POOL_GET_CREDIT_CARD_PAYMENT_METHODS = gql`
  query UserPoolGetCreditCardPaymentMethods($currency: CurrencyTypes) {
    creditCards: getCreditCardPaymentMethods(currency: $currency) {
      cardBrand
      expiryMonth
      expiryYear
      lastFourDigits
      paymentId
    }
  }
`;
